import { ArrowRight, Clock3, Eye, MapPin, ShieldAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

const severityTone = {
  CRITICA: 'border-[rgba(220,38,38,0.42)] bg-[linear-gradient(135deg,rgba(220,38,38,0.14),rgba(var(--panel),0.98))]',
  ALTA: 'border-[rgba(245,158,11,0.38)] bg-[linear-gradient(135deg,rgba(245,158,11,0.14),rgba(var(--panel),0.98))]',
  MEDIA: 'border-[rgba(234,179,8,0.32)] bg-[linear-gradient(135deg,rgba(234,179,8,0.12),rgba(var(--panel),0.98))]',
  BAJA: 'border-[rgba(var(--brand),0.28)] bg-[linear-gradient(135deg,rgba(var(--brand),0.10),rgba(var(--panel),0.98))]',
};

export default function AlertCard({
  alerta,
  entityLink,
  isNew = false,
  onOpen,
  onResolve,
}) {
  return (
    <article className={`group rounded-[1.35rem] border p-4 shadow-[0_20px_34px_rgba(var(--shadow),0.09)] transition duration-200 hover:-translate-y-[1px] hover:shadow-[0_24px_44px_rgba(var(--shadow),0.14)] ${severityTone[alerta.severidad] || severityTone.MEDIA} ${isNew ? 'alert-card-enter' : ''}`}>
      <div className="flex flex-col gap-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-[rgba(var(--fg),0.06)] px-2.5 py-1 text-[11px] font-semibold tracking-[0.14em] text-[rgb(var(--fg))]">{alerta.severidad}</span>
          <span className="rounded-full bg-[rgba(var(--panel),0.86)] px-2.5 py-1 text-[11px] font-semibold text-[rgba(var(--muted),0.95)]">{alerta.estado}</span>
          <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[rgba(var(--muted),0.92)]">{alerta.tipo}{alerta.subtipo ? ` - ${alerta.subtipo}` : ''}</span>
        </div>

        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <h3 className="text-lg font-semibold tracking-tight text-[rgb(var(--fg))]">{alerta.titulo}</h3>
            <p className="mt-1 text-sm leading-5 text-[rgba(var(--muted),0.96)]">{alerta.descripcion}</p>
          </div>
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[rgba(var(--panel),0.82)] text-[rgb(var(--brand))]">
            <ShieldAlert className="h-5 w-5" />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-2 text-xs text-[rgba(var(--muted),0.98)] sm:grid-cols-3">
          <div className="inline-flex items-center gap-2 rounded-xl bg-[rgba(var(--panel),0.72)] px-2.5 py-2">
            <MapPin className="h-3.5 w-3.5 text-[rgb(var(--brand))]" />
            {alerta.sucursalNombre || 'Sucursal no disponible'}
          </div>
          <div className="inline-flex items-center gap-2 rounded-xl bg-[rgba(var(--panel),0.72)] px-2.5 py-2">
            <Clock3 className="h-3.5 w-3.5 text-[rgb(var(--brand))]" />
            {alerta.delayLabel || (alerta.metadata?.horas ? `+${alerta.metadata.horas}h` : alerta.metadata?.tasaPct ? `${Math.round(alerta.metadata.tasaPct)}%` : alerta.relatedLabel || `${alerta.entidadTipo} #${alerta.entidadId}`)}
          </div>
          <div className="inline-flex items-center gap-2 rounded-xl bg-[rgba(var(--panel),0.72)] px-2.5 py-2">
            <Eye className="h-3.5 w-3.5 text-[rgb(var(--brand))]" />
            {alerta.relatedLabel || `${alerta.entidadTipo} #${alerta.entidadId}`}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 pt-1">
          <button type="button" onClick={onOpen} className="rounded-xl border border-[rgba(var(--border),0.78)] bg-[rgba(var(--panel),0.8)] px-3 py-2 text-sm font-semibold text-[rgb(var(--fg))]">Ver</button>
          <button type="button" onClick={onResolve} className="rounded-xl bg-[rgb(var(--brand))] px-3 py-2 text-sm font-semibold text-white">Resolver</button>
          {entityLink ? (
            <Link to={entityLink} className="inline-flex items-center gap-2 rounded-xl border border-[rgba(var(--border),0.78)] bg-[rgba(var(--panel),0.8)] px-3 py-2 text-sm font-semibold text-[rgb(var(--fg))]">
              Ir
              <ArrowRight className="h-4 w-4" />
            </Link>
          ) : null}
        </div>
      </div>
    </article>
  );
}
